/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import styles from './styles/controls.css';

export const FullScreenButton = ({isFullscreen, changeFullscreenState}) => (
  <i
    id="fullscreen"
    onClick={() => changeFullscreenState(!isFullscreen)}
    title={isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'}
    className={
      isFullscreen ? styles.exitFullscreenButton : styles.fullscreenButton
    }
  />
);

FullScreenButton.propTypes = {
  isFullscreen: PropTypes.bool.isRequired,

  changeFullscreenState: PropTypes.func.isRequired
};

export default FullScreenButton;